import React, { memo } from 'react';
import ReactModal from 'react-modal';
import { ReactSVG } from 'react-svg';

import ShutIcon from '../../assets/common/svg/shut.svg';
import SuccessIcon from '../../assets/common/svg/success.svg';
import WranIcon from '../../assets/common/svg/wran.svg';

import './MigrationModal.scss';

const MigrationModal = memo(props => {
  const {
    overlayClassName = '',
    className = '',
    zIndex,
    width,
    isOpen = false,
    closable = false,
    content,
    onClose,
    ...rest
  } = props;

  return (
    <ReactModal
      overlayClassName={`migration-modal-overlay ${overlayClassName}`}
      className={`migration-modal-content ${className}`}
      style={{
        overlay: {
          zIndex,
        },
        content: {
          width,
        },
      }}
      isOpen={isOpen}
      {...rest}
    >
      <div className="migration-modal-wrapper">
        {closable && (
          <div className="migration-modal-close">
            <ReactSVG src={ShutIcon} onClick={onClose} />
          </div>
        )}
        {content}
      </div>
    </ReactModal>
  );
});

MigrationModal.displayName = 'MigrationModal';

const MigrationSettingModal = memo(props => {
  const {
    setting,
    isOpen = false,
    closable = false,
    title,
    content,
    confirmText = '',
    cancelText = '',
    onClose,
    onConfirm,
    onCancel,
  } = props;

  const IconMap = {
    success: SuccessIcon,
    wraning: WranIcon,
  };

  const renderSettingModal = () => (
    <div className="migration-setting-modal">
      <div className="migration-setting-modal-body">
        <img
          className="migration-setting-modal-icon"
          src={IconMap[setting]}
          alt=""
        />
        <div className="migration-setting-modal-msg">
          <div className="migration-setting-modal-title">{title}</div>
          <div className="migration-setting-modal-content">{content}</div>
        </div>
      </div>

      <div className="migration-setting-modal-footer">
        {cancelText && (
          <button
            className="migration-setting-modal-cancel-button btn btn-white"
            onClick={onCancel}
          >
            {cancelText}
          </button>
        )}

        {confirmText && (
          <button
            className="migration-setting-modal-confirm-button btn btn-submit"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        )}
      </div>
    </div>
  );

  return (
    <MigrationModal
      width={416}
      isOpen={isOpen}
      closable={closable}
      content={renderSettingModal()}
      onClose={onClose}
    />
  );
});

export { MigrationSettingModal };

export default MigrationModal;



// WEBPACK FOOTER //
// ./foody/src/components/migration-confirm/MigrationModal.jsx